<template lang="pug">
    .breakdown-section
        .breakdown-chart
            SectionHeader(:title="name")
            
            v-chart.w-chart--breakdown(
                :option="chartData" 
                autoresize
            )
</template>

<script>
import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'BreakdownChart',

    components: {
        SectionHeader
    },

    props: {
        name: { 
            type: String, 
            required: true 
        },
        selectedAudienceBreakdown: { 
            type: [Object, Array], 
            required: false, 
            default: () => [] 
        }
    },

    data() {
        return {
            options: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} %'
                },
                toolbox: {
                    show: true,
                    showTitle: false
                }
            }
        }
    },

    computed: {
        chartData() {
            const breakdown = this.selectedAudienceBreakdown[this.name]

            const data = Object.entries(breakdown)
                .map(([label, data]) => {
                    return {
                        name: label,
                        value: Math.round(data.volume * 100) / 100
                    }
                })

            return {
                ...this.options,
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '50%'],
                        data,
                        label: {
                            formatter: '{b}\n{d}%',
                            fontSize: 14
                        }
                    }
                ]
            }
        }
    }
}
</script>
